import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const RegularExercise = lazyWithPreload(
  () => import('./RegularExercise'),
)
